<section class="hvac-nav-landing-page">
    <hvac-content-header [isLandingPage]="true"></hvac-content-header>
    <div class="hvac-content-container">
        <hvac-category-navigation *ngIf="(navItem$ | async)" [navItem]="(navItem$ | async)!"></hvac-category-navigation>
    </div>
</section>

<hvac-primer-frame></hvac-primer-frame>
